export const popularity = {
    'hike-5c2b1aee-62a0-448a-98f0-e82d6c7359d6' : 10, // compostelle
    'hike-c2549db0-2c4e-448f-934e-620037ce0302' : 9, // stevenson
    'hike-1073372f-cafc-4bb1-bab5-a7d7f1daec65' : 6, // St Guilhem
    'hike-628e46ac-287b-4db3-97a7-fc2548414a9e' : 5, // Aubrac
    'hike-dd2a9f86-2178-49c0-b080-81c3a36cab0f' : 3, // granit rose
    'hike-9ff65a69-5040-4203-bb4c-7ca5561d2f25' : 2, // rocamadour
    'hike-742523e2-7444-4977-90a7-ca995e57128a' : 2, // célé
    'hike-c93fd123-4551-4be1-9a2a-546dc9928c69' : 1, // cote emeraude
    'hike-97a2c577-99d1-45d5-a53e-a46e2dad1e65' : 1, // lac d'auvergne
    'hike-f085bc84-3943-4211-a573-1071eefdee82' : 1, // crozon
    'hike-98bbb53a-ee98-47e2-b954-c6b05bf68cbd' : 1, // Tarn
}